import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'Price', pure: false })

export class PricePipe implements PipeTransform {
  transform(price) {
    if(price!=null){
      price = price.replace(/\.0*$/gm,"");
        return price;
    }    
  }
}
